/* Shine & Style — cart quantity.
 *
 * A quantity typed into the box used to need a second press on an
 * "Update bag" button to take effect, and a shopper who typed 3 and
 * then pressed checkout lost the 3 without being told. The edit
 * applies itself now, and the update button only exists for
 * visitors with no script at all.
 */
(function () {
  'use strict';

  var form = document.querySelector('[data-cart-form]');
  if (!form) return;

  var submitting = false;

  Array.prototype.forEach.call(form.querySelectorAll('[data-qty]'), function (input) {
    var initial = input.value;

    function apply() {
      if (submitting) return;
      if (input.value === initial) return;

      /* An empty box is someone mid-edit, not someone asking for
         zero of something. Reverting is kinder than emptying their
         bag on a stray backspace. */
      if (input.value === '') { input.value = initial; return; }

      var n = parseInt(input.value, 10);
      if (isNaN(n) || n < 0) { input.value = initial; return; }

      submitting = true;
      form.setAttribute('aria-busy', 'true');
      input.closest('.ss-line').classList.add('is-updating');

      /* Submitted through the update button rather than by calling
         form.submit(), because a bare submit sends no button name
         and Shopify needs "update" to know what is being asked. */
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'update';
      hidden.value = '';
      form.appendChild(hidden);
      form.submit();
    }

    /* change fires on blur and on the stepper arrows of the number
       input; Enter would otherwise submit the form as a checkout. */
    input.addEventListener('change', apply);

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); apply(); }
    });
  });
})();


/* Shine & Style — adding a piece, without leaving the page.
 *
 * Pressing Add used to post the form and land the shopper on the
 * cart, which is the moment a lot of people stop shopping. The add
 * happens in place now: the piece goes in, the page says so, and it
 * offers the three things someone actually wants next - undo it, go
 * and pay, or carry on in the collection they came from.
 *
 * Everything degrades. Without this script the form posts to /cart
 * exactly as it always did, and the panel it reveals is real markup
 * with real links rather than anything built here.
 */
(function () {
  'use strict';

  var form = document.getElementById('ss-product-form');
  var panel = document.querySelector('[data-added]');
  if (!form || !panel) return;

  /* EasySell replaces this button with its own cash-on-delivery
     form when it is switched on. If it ever is, it owns the add and
     this must not intercept it. Reading the app's own status rather
     than sniffing for its markup, because the markup only appears
     after it has decided to run. */
  var easysell = window.EASYSELL_CONFIG;
  if (easysell && easysell.status && easysell.status !== 'disabled') return;

  var addButtons = document.querySelectorAll('button[name="add"]');
  var undo = panel.querySelector('[data-undo-add]');
  var select = document.querySelector('[data-variant-select]');
  var busy = false;
  var lastVariant = null;

  /* Three things can hold the button down: a request in flight, the
     piece already being in the bag, and the variant being sold out.
     They are tracked separately and applied in one place, because
     the alternative is each of them fighting the other two over the
     same disabled attribute. */
  var added = false;

  function refreshButtons() {
    Array.prototype.forEach.call(addButtons, function (b) {
      var soldOut = b.hasAttribute('data-sold-out');

      /* Only a genuinely sold-out variant disables this button now.
         It used to be disabled for "already in the bag" as well, and
         that quietly broke ordering: EasySell watches this exact
         button and reads `disabled` as the product being sold out, so
         the moment anything went into the bag it relabelled its own
         COD button "Sold Out", set pointer-events:none and dropped it
         to half opacity. The piece was in the bag and there was no
         longer any way to buy it. */
      b.disabled = busy || soldOut;
      b.classList.toggle('is-added', added && !soldOut);

      /* All three labels ride on the button as data attributes, so
         this swaps them without knowing which language the page is
         in. Sold out wins over added: a variant that cannot be sold
         should not be offering "Order again". ss-variants.js writes
         data-sold-out on every variant change, so this is the live
         answer and not just how the page was first rendered. */
      var label = b.getAttribute(
        soldOut ? 'data-label-sold' : (added ? 'data-label-added' : 'data-label-add')
      );
      if (label && b.textContent.trim() !== label) b.textContent = label;
    });

    /* Drives hiding EasySell's COD button once this piece is in the
       bag - see ss-cart.css. Ordering continues from the bag, where
       the same button is waiting. */
    document.documentElement.classList.toggle('ss-ordered', added);
  }

  function setBusy(state) {
    busy = state;
    refreshButtons();
  }

  function bumpCount(delta) {
    var el = document.querySelector('[data-cart-count]');
    if (!el) return;
    var n = (parseInt(el.textContent, 10) || 0) + delta;
    el.textContent = n < 0 ? 0 : n;
    /* ss-mobile.js watches this and hides the badge at zero. */
  }

  /* The button stays on the page and changes what it says, rather
     than disappearing. Something vanishing from under a thumb is
     disorienting; "Order again" says both that the last press
     worked and what this press will do. The panel underneath says
     the rest, and carries the way out - view the bag, keep looking,
     or take it back. */
  function show() {
    added = true;
    refreshButtons();
    panel.hidden = false;
    /* Announced, not just drawn - a shopper using a screen reader
       gets no signal from a panel appearing. */
    panel.setAttribute('role', 'status');
    panel.setAttribute('aria-live', 'polite');
  }

  function hide() {
    added = false;
    refreshButtons();
    panel.hidden = true;
  }

  form.addEventListener('submit', function (e) {
    if (busy) { e.preventDefault(); return; }
    var id = select ? select.value : null;
    if (!id) return;                    // no variant resolved: let it post

    e.preventDefault();
    setBusy(true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () {
        lastVariant = id;
        bumpCount(1);
        show();
      })
      .catch(function () {
        /* Sold out under them, or the network went. Falling back to
           a normal post means Shopify explains it on the cart page
           rather than this quietly doing nothing. */
        form.submit();
      })
      .then(function () { setBusy(false); });
  });

  if (undo) {
    undo.addEventListener('click', function () {
      if (busy || !lastVariant) return;
      setBusy(true);

      /* change.js takes a variant id and a quantity, so setting it
         to zero removes the line without having to look up its key
         first. */
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: String(lastVariant), quantity: 0 })
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () {
          bumpCount(-1);
          lastVariant = null;
          hide();
        })
        .catch(function () {
          /* Could not undo it here, so send them where they
             certainly can rather than leaving them stuck. */
          window.location.href = '/cart';
        })
        .then(function () { setBusy(false); });
    });
  }

  /* Choosing a different size or colour means they are looking at a
     different piece now, so the panel stops describing what is on
     screen. */
  /* Picking a different size or colour is a different piece, so the
     button comes back to life and the panel stops describing what is
     on screen. This is the only way back to an enabled button short
     of removing the item.

     ss-variants.js also sets disabled from availability on these
     same events; clearing the flag first means the two agree
     instead of overwriting each other. */
  Array.prototype.forEach.call(
    document.querySelectorAll('[data-option-value], [data-variant-select]'),
    function (el) {
      var reset = function () { if (added) hide(); };
      el.addEventListener('click', reset);
      el.addEventListener('change', reset);
    }
  );
})();


/* Shine & Style — adding from the grid.
 *
 * Same bargain as the product page: it goes in without leaving the
 * page, the control says so, and it stays visible but spent so
 * nobody adds the same thing twice by accident. Pressing it again
 * takes it back out, because on a card there is no variant to
 * change - undo is the only way back.
 *
 * Delegated from the document, because cards arrive in tab panels
 * and carousels that are rendered before this runs and swapped
 * after it.
 */
(function () {
  'use strict';

  var easysell = window.EASYSELL_CONFIG;
  if (easysell && easysell.status && easysell.status !== 'disabled') return;

  function bumpCount(delta) {
    var el = document.querySelector('[data-cart-count]');
    if (!el) return;
    var n = (parseInt(el.textContent, 10) || 0) + delta;
    el.textContent = n < 0 ? 0 : n;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-card-add]');
    if (!btn) return;

    /* The whole card is a link. Without both of these, adding also
       navigates to the product - which is precisely the leaving-the
       -page this exists to avoid. */
    e.preventDefault();
    e.stopPropagation();

    if (btn.disabled || btn.dataset.busy === '1') return;

    var id = btn.getAttribute('data-variant-id');
    var added = btn.classList.contains('is-added');
    btn.dataset.busy = '1';

    var request = added
      ? fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: String(id), quantity: 0 })
        })
      : fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        });

    request
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () {
        if (added) {
          btn.classList.remove('is-added');
          btn.textContent = btn.getAttribute('data-label-add');
          bumpCount(-1);
        } else {
          btn.classList.add('is-added');
          btn.textContent = btn.getAttribute('data-label-added');
          bumpCount(1);
        }
      })
      .catch(function () {
        /* Sold out under them, or the network went. The product
           page can explain it; a card cannot. */
        window.location.href = btn.closest('.ss-card').querySelector('a[href]').getAttribute('href');
      })
      .then(function () { btn.dataset.busy = '0'; });
  });
})();


/* Shine & Style — standing aside for EasySell on the cart.
 *
 * The shop sells cash on delivery, and when the EasySell form is on it
 * is the whole checkout: name, phone, address, done, without ever
 * reaching Shopify's checkout. Two buttons stacked - "Checkout" and
 * "Buy with Cash on Delivery" - is the same choice asked twice, and on
 * a page whose entire job is one decision that is the wrong thing to
 * show.
 *
 * So ours steps down. Not by being deleted from the markup: it is a
 * real submit button inside a real form, and it is the only way to pay
 * if EasySell is off, mid-outage, or excluded on this cart by its own
 * country and total rules.
 *
 * The trigger is EasySell's button actually existing. Reading its
 * config and hiding ours pre-emptively would empty the cart of any way
 * to pay every time the app decided, for its own reasons, not to
 * render - and it decides that after the config says it is enabled.
 * Waiting for the button means the swap can only ever happen when
 * there is something to swap to.
 */
(function () {
  'use strict';

  var mine = document.querySelector('[data-checkout]');
  if (!mine) return;

  /* Off at the source. Nothing will ever appear, so don't watch. */
  var cfg = window.EASYSELL_CONFIG;
  if (!cfg || cfg.status === 'disabled' || cfg.status === 'error') return;

  /* #es-popup-button is the popup trigger; #easysell is the embedded
     form. Either one means EasySell has taken the page. */
  function theirs() {
    var el = document.querySelector('#es-popup-button, .es-popup-button');
    if (el) return el;
    var form = document.getElementById('easysell');
    /* It exists from the start and is revealed by display:block, so
       presence alone is not enough to go on. */
    return form && form.offsetParent !== null ? form : null;
  }

  var done = false;
  function check() {
    if (done || !theirs()) return;
    done = true;
    document.body.classList.add('ss-easysell-on');
    return true;
  }

  if (check()) return;

  /* It renders after its own async init, and again after a cart
     update, so watch rather than poll. Disconnected on the first hit
     and after fifteen seconds, so nothing is left observing the whole
     document for the life of the page. */
  if (!('MutationObserver' in window)) {
    window.addEventListener('load', check);
    return;
  }

  var mo = new MutationObserver(function () {
    if (check()) mo.disconnect();
  });
  mo.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { mo.disconnect(); }, 15000);
})();
